
<main class="all-transport-list__content">
  @if(transportList().length > 0){
    <ul class="content__transport-item-list">
      @for(transport of transportList(); track transport.id) {
        @if (!transportId() || transport.id === transportId()) {
          <li class="content__transport-item">
            <app-transport-icon [iconName]="transport.iconName" />
            
            <div class="content__transport-info">
              <app-transport-name [name]="transport.name" />

              <app-transport-duration [duration]="transport.duration" />
              
              @if(transport.stopDetails) {
                <app-transport-stop-details [stopDetails]="transport.stopDetails" />
              }
            </div>
          </li>
        }
      }
    </ul>
  }
</main>